export enum WhatsappTemplates {
  reinitialise = 'We\'d like to update you about your query. Are you happy to continue on WhatsApp?',
  new_ticket = 'Hi, this is {{ practice }} and we\'d like to message you regarding your account or pet. Are you happy to continue on WhatsApp?',
}
